export default {
    en: {
        unqualified: 'The image quality is unqualified',
        reUpload: 'please upload again'
    },
    zh: {
        unqualified: '图片质量不合格',
        reUpload: '请重新上传'
    }
};
